import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import type { ItemBuildReportFilter, ItemBuildReportRow } from "../types/itemBuildReport"

export function useItemBuildReport(filter: ItemBuildReportFilter) {
  const api = useApi()
  const [data, setData] = useState<ItemBuildReportRow[]>([])
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()

  const keyword = filter.keyword?.trim() ?? ""

  useEffect(() => {
    if (!filter.start_date || !filter.end_date) {
      setData([])
      setLoading(false)
      setError(undefined)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(undefined)

    const params: Record<string, string | number> = {
      start_date: filter.start_date,
      end_date: filter.end_date,
      category_id: Number(filter.category_id) || 0,
      location_id: Number(filter.location_id) || 0,
      approve_staus: Number(filter.approve_status) || 0,
    }

    if (keyword) {
      params.search = keyword
    }

    api
      .get("/list_build_item/report_builditem", { params })
      .then((res: SuccessFetch<{ payload: ItemBuildReportRow[] }>) => {
        if (cancelled) return
        const rows = res.data?.payload
        setData(Array.isArray(rows) ? rows : [])
      })
      .catch(() => {
        if (cancelled) return
        setData([])
        setError("Failed to load report data")
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
    // api dari useApi() instance baru tiap render — jangan masuk dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filter.start_date,
    filter.end_date,
    filter.category_id,
    filter.location_id,
    filter.approve_status,
    keyword,
  ])

  return { data, isLoading, error }
}
